import { getKsdmConfig } from 'helpers/index';

/**
 * Phase 7a — `footer#ksdm-footer`, partners variant
 * (`django/templates/common/partnersBase.html:20-34`).
 *
 * Like `sizerBase.html` this shell inlines its own footer instead of including
 * `common/footer.html`, so it cannot reuse `PageFooter`. It differs from the
 * sizer's in exactly one way — the outer wrapper is
 * `col-xs-9 col-xs-offset-3`, not `col-xs-12` — which matters because
 * `styles.css:560-568` styles `#ksdm-footer > div` and `#ksdm-footer .left`.
 *
 * The version block is rendered UNCONDITIONALLY (no `{% if %}` guard in the
 * template, so the pipes show even with empty versions). `versions.cms` is the
 * composed `C.{Ymd}.{version}` token that `react_views._cms_version` builds —
 * the same string `partnersBase.html:29` assembles inline.
 */
const PartnersFooter = () => {
  const cfg = getKsdmConfig();
  const year = cfg?.year ?? new Date().getFullYear();
  const software = cfg?.versions?.software ?? '';
  const master = cfg?.versions?.master ?? '';
  const cmsVersion = cfg?.versions?.cms ?? '';

  return (
    <footer id="ksdm-footer">
      <div className="col-xs-9 col-xs-offset-3">
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 right">
          <small id="ksdm-copyright" className="right">
            Powered by Kinetix Air | &#169; {year} Kinetix Software LLC | All Rights Reserved
          </small>
        </div>
        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 left">
          <small id="ksdm-dbs-version" className="">
            <span className="ka-has-tooltip" tooltip="Software version">
              {software}
            </span>{' '}
            |{' '}
            <span className="ka-has-tooltip" tooltip="Master DB version">
              {master}
            </span>{' '}
            |{' '}
            <span className="ka-has-tooltip cms_version" tooltip="CMS DB version">
              {cmsVersion}
            </span>
          </small>
        </div>
      </div>
    </footer>
  );
};

export default PartnersFooter;
